module.exports = __webpack_public_path__ + "static/media/JA_My_Way.b0a3bc1b.png";